import { SelectorChain } from '@fullstory/proto/fs/selectors';
import { cloneChain, conservativeShorten, forEachRule, trimOnValidID } from '../selector';

const DATA_SOURCE_FILE = 'data-source-file';
const DATA_ELEMENT = 'data-element';
const DATA_COMPONENT = 'data-component';
const TESTID = 'testid';

function trimAttributesRN(chain: SelectorChain): void {
  // Trim <View>
  if (
    chain.rule?.tag === 'RCTView' ||
    chain.rule?.tag === 'reactviewgroup' ||
    chain.rule?.tag === 'RCTTextView' ||
    chain.rule?.tag === 'reacttextview' ||
    chain.rule?.tag === 'RNSScreenView'
  ) {
    if (
      chain.rule.attrs[DATA_ELEMENT] === 'Component' ||
      chain.rule.attrs[DATA_ELEMENT] === 'View'
    ) {
      delete chain.rule.attrMatch[DATA_ELEMENT];
      delete chain.rule.attrs[DATA_ELEMENT];
    }

    if (
      // React Reanimated
      (chain.rule.attrs[DATA_SOURCE_FILE] === 'createAnimatedComponent.tsx' ||
        chain.rule.attrs[DATA_SOURCE_FILE] === 'createAnimatedComponent.js') &&
      (chain.rule.attrs[DATA_COMPONENT] === 'AnimatedComponent' ||
        chain.rule.attrs[DATA_COMPONENT] === 'Component')
      // react-native-gesture-handler
    ) {
      delete chain.rule.attrMatch[DATA_SOURCE_FILE];
      delete chain.rule.attrs[DATA_SOURCE_FILE];
      delete chain.rule.attrMatch[DATA_COMPONENT];
      delete chain.rule.attrs[DATA_COMPONENT];
    }

    if (
      chain.rule.attrs[DATA_SOURCE_FILE] === 'GestureHandlerRootView.tsx' ||
      chain.rule.attrs[DATA_SOURCE_FILE] === 'GestureHandlerRootView.js'
    ) {
      chain.rule.attrs = {};
      chain.rule.attrMatch = {};
    }
  } else if (chain.rule?.tag === 'reactscrollview' || chain.rule?.tag === 'RCTScrollView') {
    if (chain.rule.attrs[DATA_ELEMENT] === 'NativeDirectionalScrollView') {
      chain.rule.attrs = {};
      chain.rule.attrMatch = {};
    }
  }
}

// Don't display any views higher than these in the selector chain
function trimOnRootViewsRN(chain: SelectorChain): boolean {
  if (
    chain.rule?.attrs[DATA_COMPONENT] === 'GestureHandlerRootView' ||
    chain.rule?.tag === 'safeareaprovider' ||
    chain.rule?.tag === 'screencontainer'
  ) {
    chain.parent = null;
    chain.combinator = '';
    chain.rule.attrs = {};
    chain.rule.attrMatch = {};
    return true; // stop
  }
  return false;
}

// For React Native session, treat the "testid" attribute as the main identifying selector 
function trimOnTestIdRN(chain: SelectorChain): boolean {
  if (chain.rule?.attrs[TESTID] && chain.rule?.attrMatch[TESTID]) {
    chain.rule.attrs = { [TESTID]: chain.rule.attrs[TESTID] };
    chain.rule.attrMatch = { [TESTID]: chain.rule.attrMatch[TESTID] };
    // iOS maps testid to id, so we erase it here to dedupe
    chain.rule.id = '';
    chain.rule.classes = [];
    chain.rule.tag = '';
    chain.parent = null;
    chain.combinator = '';
    return true; // stop
  }
  return false;
}

function selectorShortenReactNative(sel: SelectorChain, limit: number): SelectorChain {
  let d = 0;
  const shortened = cloneChain(sel);
  forEachRule(shortened, chain => {
    if (d === limit - 1) {
      chain.parent = null;
      chain.combinator = "";
      return true; // stop
    }

    if (trimOnTestIdRN(chain) || trimOnValidID(chain) || trimOnRootViewsRN(chain)) {
      return true;
    }

    trimAttributesRN(chain);
    d++;
    return false; // Don't stop
  });
  return shortened;
}

export function HumanReadableMobile(sel: SelectorChain, isReactNative: boolean): SelectorChain {
  if (isReactNative) {
    return selectorShortenReactNative(sel, 9)
  }
  return conservativeShorten(sel, 3)
}